import { useNotify, useDataProvider } from 'react-admin';
import { useEffect, useState } from "react";
import InputFieldCustom from '../Commons/InputFieldCustom'
import { useMediaQuery } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Validate from '../Commons/Validate';
import CircularProgress from '@mui/material/CircularProgress';
import BreadCrumbCustom from '../Commons/BreadCrum';
import historyTracker from '../Commons/historyTracker';
import { useNavigate, useLocation } from 'react-router-dom';
import { Style } from '../Commons/Styles.jsx';
import BottomToolBar from '../Commons/BottomToolBar';
import AuthNotification from '../Commons/AuthNotification';
import InternalMenu from '../Commons/InternalMenu';
// TODO: reemplazar por el ícono definitivo de Proveedores cuando esté disponible
import providers from '../Commons/Icons/apps.svg';
import providerList from '../Commons/Icons/book.svg';

import { hasPermissions } from '../Commons/CompanyAuth';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// Catalogo de tipo_factura: no existe un SP que lo liste por mnemonico (gecatalogos/
// gecatalogosdominios solo se consultan por correlativo), pero es una lista fija que
// se sembro una sola vez en la base (ver Tablas/cbfactura.sql, catalogo
// "Tipos de facturas de proveedores"). El SP valida server-side que el codigo elegido
// corresponda al regimen fiscal del proveedor (Pequeño Contribuyente vs Regimen General).
const InvoiceTypes = [
    { key: 'FACT', value: 'Factura' },
    { key: 'FCAM', value: 'Factura cambiaria' },
    { key: 'FPEQ', value: 'Factura peq. contribuyente' },
    { key: 'FCAP', value: 'Factura camb. peq. contribuyente' },
    { key: 'FESP', value: 'Factura especial' },
    { key: 'FACA', value: 'Fact. cont. agropecuario' },
    { key: 'FCCA', value: 'Fact. camb. agropecuario' },
    { key: 'FAPE', value: 'Fact. peq. contribuyente reg. elec.' },
    { key: 'FCPE', value: 'Fact. camb. peq. contrib. reg. elect.' },
    { key: 'FAAE', value: 'Fact. contr. agro. regimen elec. esp.' },
    { key: 'FCAE', value: 'Fact. camb. contr. agro. reg. elec esp.' },
];

// El proveedor (codigo y nombre) llega desde ProviderInvoicesList por query string
// (?provider=...&providerName=...), no por location.state: el codigo_proveedor nunca se
// muestra en este formulario, solo se manda al crear, asi que la query es la unica fuente
// que necesita. location.state queda como respaldo por si acaso, pero no es lo principal.
const getProviderCode = (location) => {
    try {
        const params = new URLSearchParams(location?.search || '');
        const fromQuery = params.get('provider');
        if (fromQuery) return fromQuery;
    } catch {
        // sigue al respaldo de abajo
    }
    return location?.state?.providerCode || null;
};

const getProviderName = (location) => {
    try {
        const params = new URLSearchParams(location?.search || '');
        const fromQuery = params.get('providerName');
        if (fromQuery) return fromQuery;
    } catch {
        // sigue al respaldo de abajo
    }
    return location?.state?.providerName || null;
};

const ProviderInvoiceCreate = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const location = useLocation();
    const providerCode = getProviderCode(location);
    const providerName = getProviderName(location);

    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [invoiceAmount, setInvoiceAmount] = useState('0.00');
    const [concept, setConcept] = useState('');
    const [currency, setCurrency] = useState(null);
    const [currencies, setCurrencies] = useState([]);
    const [invoiceType, setInvoiceType] = useState('FACT');
    const [series, setSeries] = useState('');
    const [passwordNumber, setPasswordNumber] = useState('');
    const [reimbursementSubject, setReimbursementSubject] = useState('');
    const [reimbursementSubjects, setReimbursementSubjects] = useState([]);

    const [openerror, setOpenerror] = useState(false);
    const [message, setMessage] = useState('');
    const [opacity, setOpacity] = useState(1);
    const [displayLoading, setDisplayLoading] = useState('none');
    const [disable, setDisable] = useState(false);
    const [openAuth, setOpenAuth] = useState(false);
    const [auth, setAuth] = useState(false);
    // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
    // "initialLoading" en el return): esta pantalla necesita traer permisos, monedas
    // y sujetos de reembolso antes de poder mostrar el formulario, y sin este estado
    // la ventana se veia en blanco (solo el breadcrumb) durante esa espera.
    const [initialLoading, setInitialLoading] = useState(true);
    const dataProvider = useDataProvider();

    const notify = useNotify();

    const handleClickError = () => {
        setOpenerror(true);
    };

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenerror(false);
    };

    useEffect(() => {
        (async () => {
            try {
                const currentPath = location.pathname;
                historyTracker.addPath(currentPath, providerName ? `Crear Factura - ${providerName}` : 'Crear Factura', 5);

                const authdata = { data: hasPermissions('ProviderInvoice', 'create') };
                if (authdata.data.length > 0) {
                    setAuth(authdata.data[0]);
                    setOpenAuth(!authdata.data[0]);

                    if (authdata.data[0]) {
                        const [currenciesData, reimbursementData] = await Promise.all([
                            dataProvider.getList('currency', { filter: {}, pagination: {}, sort: {} }),
                            dataProvider.getList('provider/reimbursementsubjects', { filter: {}, pagination: {}, sort: {} })
                        ]);

                        var currenciesList = currenciesData.data.map(item => ({ key: item.id, value: item.name }));
                        setCurrencies(currenciesList);
                        if (currenciesList.length > 0)
                            setCurrency(currenciesList[0].key);

                        var reimbursementList = reimbursementData.data.map(item => ({ key: item.id, value: item.name }));
                        setReimbursementSubjects([{ key: '', value: 'Ninguno' }, ...reimbursementList]);
                    }
                } else {
                    setAuth(false);
                    setOpenAuth(true)
                }
            }
            catch {
            }
            finally {
                setInitialLoading(false);
            }
        })();
    }, [dataProvider, location.pathname, providerName]);

    const PostInvoice = async () => {
        let control = 0;

        if (!providerCode) {
            setMessage("No se pudo determinar el proveedor de esta factura");
            handleClickError();
            return;
        }

        if (!Validate(invoiceNumber, { required: true }))
            control++;

        if (!Validate(invoiceDate, { required: true, date: true }))
            control++;

        if (!Validate(paymentDate, { required: true, date: true }))
            control++;

        if (!Validate(invoiceAmount, { money: true, required: true }))
            control++;

        if (!Validate(concept, { required: true }))
            control++;

        if (!Validate(series, { required: true }))
            control++;

        if (control > 0) {
            setMessage("No se pudo crear la Factura");
            handleClickError();
            return;
        }

        setOpacity(0.3);
        setDisable(true);
        setDisplayLoading('block');

        var info = {
            provider: providerCode,
            invoiceNumber,
            invoiceDate,
            paymentDate,
            invoiceAmount: invoiceAmount.toString().replace(/[^0-9.-]/g, ''),
            concept,
            currency,
            invoiceType,
            series,
            passwordNumber,
            reimbursementSubject: reimbursementSubject || null,
        }

        dataProvider.create('provider/invoice', { data: info })
            .then(() => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                notify('Factura creada correctamente');
                navigate({
                    pathname: '/provider/invoice',
                    search: `?filter=${encodeURIComponent(JSON.stringify({ provider: providerCode }))}&providerName=${encodeURIComponent(providerName || '')}`,
                }, { state: { providerName, providerCode } });
            })
            .catch((error) => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                setMessage("No se pudo crear la Factura. " + error.toString().replace('HttpError: ', ''));
                handleClickError()
            })
    }

    const handleRedirectProviderList = () => {
        navigate(`/provider`);
    };

    const handleRedirectInvoices = () => {
        navigate({
            pathname: '/provider/invoice',
            search: `?filter=${encodeURIComponent(JSON.stringify({ provider: providerCode }))}&providerName=${encodeURIComponent(providerName || '')}`,
        }, { state: { providerName, providerCode } });
    };

    const [openProviders, setOpenProviders] = useState(true);

    const handleClickOpenProviders = () => {
        setOpenProviders(!openProviders);
    };

    const menus = [{
        icon: <img src={providers} alt="logo" style={Style.MenuLogo} />, name: 'Proveedores',
        open: openProviders,
        openAction: handleClickOpenProviders,
        actions: [
            { icon: <img src={providerList} alt="logo" style={Style.MenuLogo} />, name: 'Listado', onClick: handleRedirectProviderList },
        ]
    }];

    return (
        <div class="container">
            <BreadCrumbCustom history={historyTracker.getHistory()} />
            {initialLoading ? (
                // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
                // el mismo CircularProgress que ya se usaba para el guardado (mas abajo,
                // controlado por displayLoading), pero aqui cubre la espera de auth +
                // monedas + sujetos de reembolso, que antes dejaba la pantalla en blanco.
                <div class="Loading" style={{ display: 'block' }}>
                    <CircularProgress size="15rem" />
                </div>
            ) : auth ? (
                // paddingBottom en linea recorta el padding-bottom:2em fijo que trae la clase
                // "edit" (index.css) solo para esta pantalla -- mismo ajuste que
                // AccountingExpenseCreate.jsx: el formulario es corto y con el padding de 2em
                // completo mas el marginTop de arriba (ver mas abajo, antes del boton), quedaba
                // mucho mas aire abajo del boton que arriba. No se toco la clase "edit" en si
                // porque la comparten todas las pantallas de Crear/Show.
                <div class="edit" style={{ paddingBottom: '0.1em' }}>
                    {!isSmall ? (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>) : (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>
                    )}
                    {!isSmall ? (
                        <div class="container" style={{ opacity: opacity }}>
                            {/* col-3 (4 por fila), igual que el resto de pantallas de Crear/Show
                                (AccountingExpenseCreate, ProviderInvoiceShow, etc.). El textarea
                                de Concepto (mas abajo) recibe referenceCol="col-3" para que su
                                calculo de ancho (computeTextareaWidth en InputFieldCustom) sepa que
                                el modulo de esta pantalla es col-3 y su borde derecho termine donde
                                terminaria un campo col-3 mas -- si se cambia el modulo de columnas
                                de esta pantalla, actualizar tambien ese "referenceCol" o el
                                textarea vuelve a quedar mal alineado. */}
                            <div class="row">
                                <InputFieldCustom value={invoiceNumber} setValue={setInvoiceNumber} col="col-3" width="95%" placeholder="Ingresa el número de factura" label="No. Factura *" required type="text" />
                                <InputFieldCustom value={invoiceDate} setValue={setInvoiceDate} col="col-3" width="95%" label="Fecha de Factura *" required type="date" date />
                                <InputFieldCustom value={paymentDate} setValue={setPaymentDate} col="col-3" width="95%" label="Fecha de Pago *" required type="date" date />
                                <InputFieldCustom value={invoiceAmount} setValue={setInvoiceAmount} col="col-3" width="95%" placeholder="Ingresa el monto" label="Monto (Q) *" required type="text" money />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setCurrency} value={currency} options={currencies} component="select" label="Moneda" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setInvoiceType} value={invoiceType} options={InvoiceTypes} component="select" label="Tipo de Factura" />
                                <InputFieldCustom value={series} setValue={setSeries} col="col-3" width="95%" placeholder="Ingresa la serie" label="Serie *" required type="text" />
                                <InputFieldCustom value={passwordNumber} setValue={setPasswordNumber} col="col-3" width="95%" placeholder="S/C si no aplica" label="Número de Contraseña" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setReimbursementSubject} value={reimbursementSubject} options={reimbursementSubjects} component="select" label="Sujeto de Reembolso" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={concept} setValue={setConcept} col="col-12" width="95%" placeholder="Ingresa el concepto" label="Concepto *" required type="text" component="textarea" referenceCol="col-3" />
                            </div>
                            {/* Espacio extra antes del boton (ademas del marginTop propio de
                                BottomToolBar) para que no quede pegado a la ultima fila del
                                formulario -- mismo ajuste que AccountingExpenseCreate.jsx. */}
                            <div style={{ marginTop: '2em' }}>
                                <BottomToolBar buttons={[{ auth: true, action: PostInvoice, name: 'Crear' }, { auth: true, action: handleRedirectInvoices, name: 'Cancelar' }]} disabled={disable} menu={<InternalMenu menus={menus} />} />
                            </div>
                        </div>
                    ) : (
                        <div class="container" style={{ opacity: opacity }}>

                        </div>)
                    }
                    <div class="row" style={Style.Alert}>
                        <div>
                            <Snackbar open={openerror} autoHideDuration={4000} onClose={handleCloseError}>
                                <div>
                                    <Alert onClose={handleCloseError} severity="error" style={Style.AlertMessage} >
                                        {message}
                                    </Alert>
                                </div>
                            </Snackbar>
                        </div>
                    </div>
                </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)}
        </div>
    )
}

export default ProviderInvoiceCreate
